/**
 * The thirteen collections of the Living Library + the Search door.
 * Ids must stay in sync with LIBRARY_CATEGORIES in backend/library_service.py.
 * Titles and descriptions live in i18n (library.cats.{id}.title/.desc).
 */
import {
  Landmark, Network, Compass, Repeat, ScrollText, Hourglass, FlaskConical,
  Crown, Users, HeartPulse, Coins, Building2, BookMarked, Search,
} from "lucide-react";

export const LIBRARY_CATEGORIES = [
  { id: "philosophers",  Icon: Landmark },
  { id: "concepts",      Icon: Network },
  { id: "virtues",       Icon: Compass },
  { id: "practices",     Icon: Repeat },
  { id: "sources",       Icon: ScrollText },
  { id: "history",       Icon: Hourglass },
  { id: "research",      Icon: FlaskConical },
  { id: "leadership",    Icon: Crown },
  { id: "relationships", Icon: Users },
  { id: "health",        Icon: HeartPulse },
  { id: "finance",       Icon: Coins },
  { id: "society",       Icon: Building2 },
  { id: "glossary",      Icon: BookMarked },
];

export const SEARCH_CARD = { id: "search", Icon: Search };

export function getCategory(id) {
  return LIBRARY_CATEGORIES.find((c) => c.id === id) || null;
}
